<template lang="pug">
main.layout__main.pt-0
  .overlay.overlay_light.overlay_flex.overlay_fixed(
    style="z-index: 90",
    v-show="pageIsLoading"
  )
    .overlay__content
      .loader
  section.club-intro.section.mt-0
    .container.container_mobile
      .grid.grid_h-center
        .grid__col.grid__col_xl-20
          .club-cover(
            :style="isLoaded && 'background-image: url(' + coverImg + ')'"
          )
            Skeleton(v-if="!isLoaded", width="100%", height="100%")
            .club-cover__empty(
              v-else-if="!coverImg",
              :style="'background-image: url(' + logo + ')'"
            )
              .overlay
            .overlay.overlay_light.overlay_flex(v-if="coverIsLoading")
              .overlay__content
                .loader
                div Загрузка обложки...
            InputFile.d-none(
              name="club_cover",
              :maxSize="coverImgMaxSize",
              @change="loadCover",
              ref="clubCoverInput"
            )
          .club-header
            .section__item.section__item_md
              .grid.grid_v-bottom.grid_v-margins
                .grid__col.grid__col_md-stretch
                  .club-avatar
                    img(
                      v-if="isReady",
                      :src="logo || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk5AIAABIADYqAqfgAAAAASUVORK5CYII='",
                      @error="($event) => ($event.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk5AIAABIADYqAqfgAAAAASUVORK5CYII=')",
                      alt=""
                    )
                    Skeleton(height="100%", v-else)
                  h1.club-title
                    template(v-if="isReady") {{ info && info.name }}
                    Skeleton(width="600px", v-else)
                  .club-details
                    template(v-if="!isReady")
                      .club-details__item
                        Skeleton(width="50px")
                      .club-details__item
                        Skeleton(width="80px")
                      .club-details__item
                        Skeleton(width="80px")
                    template(v-else-if="info")
                      .club-details__item
                        b.text-with-icon
                          icon.icon(icon-name="user-groups", w="18", h="18")
                          span {{ info.membersCount || 0 }}
                      .club-details__item(
                        v-if="isPrivate"
                      )
                        b.text-with-icon
                          icon.icon(icon-name="lock", w="18", h="18")
                          span Корпоративный
                      .club-details__item(v-if="info.isManager")
                        b.text-with-icon.color-success
                          icon.icon(icon-name="check-bold", w="18", h="18")
                          span Вы владелец
                      .club-details__item(v-else-if="isMember")
                        b.text-with-icon.color-success
                          icon.icon(icon-name="check-bold", w="18", h="18")
                          span Вы участник
                      .club-details__item(v-else-if="!isPrivate && hasMemberRequest")
                        b.text-with-icon.color-warning
                          icon.icon(icon-name="check-bold", w="18", h="18")
                          span Вы подали заявку
                .club-buttons-col.grid__col.grid__col_md-auto(v-if="isLoaded")
                  .club-buttons
                    template(v-if="!isPrivate")
                      .club-buttons__item(v-if="hasMemberRequest" key="cancelButton")
                        button.button.button_secondary(
                          :class="{ button_loading: isCancelling }",
                          :disabled="isCancelling",
                          @click.prevent="cancel"
                        )
                          span.button__text Отменить заявку
                          span.button__icon.button__loading
                            icon(icon-name="loading")
                      .club-buttons__item(v-else-if="!isMember" key="joinButton")
                        button.button.button_primary(
                          :class="{ button_loading: isJoining }",
                          :disabled="isJoining",
                          @click.prevent="join(false)"
                        )
                          span.button__text Вступить в&nbsp;клуб
                          span.button__icon.button__loading
                            icon(icon-name="loading")
                          span.button__icon.button__done
                            icon(icon-name="check-bold")
                      .club-buttons__item(v-else-if="isMember" key="shareButton")
                        button.button.button_primary(
                          v-open-modal="{name: 'invite-friends-modal'}"
                        )
                          span.button__icon
                            icon(icon-name="plus")
                          span.button__text Пригласить
                    .club-buttons__item(v-else-if="info.isManager" key="shareButton2")
                      button.button.button_primary(
                        v-open-modal="{name: 'invite-friends-modal'}"
                      )
                        span.button__icon
                          icon(icon-name="plus")
                        span.button__text Пригласить
                    .club-buttons__item(
                      v-if="info.isManager || isMember"
                      key="moreButton"
                    )
                      button.button.button_secondary.button_square(
                        ref="moreActions"
                      )
                        span.button__icon
                          icon(icon-name="more-horizontal")
                      Dropdown(trigger="moreActions", placement="bottom-end")
                        template(slot="items")
                          .dropdown__item(v-for="action in actions")
                            .divider(v-if="action.isDivider")
                            a.dropdown__link(
                              href="#",
                              @click.prevent="action.action",
                              v-else
                            )
                              .dropdown__icon
                                icon(:icon-name="action.icon")
                                span.dropdown__icon-badge(v-if="action.iconBadge > 0")
                              span.dropdown__text {{ action.name }}
            .divider.m-0
            TabsNav#clubTabs(:items="nav")
  section.section.m-0
    .section__group
      router-view(
        :club="isLoaded ? clubInfo : null",
        :clubId="$route.params.id"
      )
  InviteFriendsModal
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { Skeleton } from 'vue-loading-skeleton'
import TabsNav from '@/components/TabsNav'
import InputFile from '@/components/InputFile'
import Alert from '@/components/Alert'
import InviteFriendsModal from './Club/includes/InviteFriendsModal'

export default {
  name: 'Club',
  components: {
    TabsNav,
    InputFile,
    Alert,
    InviteFriendsModal,
    Skeleton
  },
  data () {
    return {
      coverImg: null,
      coverImgMaxSize: 5,
      hasTraining: false,
      pageIsLoading: false,
      isJoining: false,
      isCancelling: false,
      coverIsLoading: false
    }
  },
  computed: {
    ...mapState('user', ['isAuthorized', 'user']),
    ...mapState('club', [
      'clubCode',
      'clubInfo',
      'clubActivitiesCount',
      'infoUpdateTrigger',
      'requestsCount',
      'clubStartsCount'
    ]),
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    },
    info () {
      return this.isLoaded ? this.clubInfo : this.$route.params.data
    },
    isPrivate () {
      return this.info.clubPrivacy === 'private' || this.info.clubPrivacy === 2
    },
    isMember () {
      return this.info && this.info.membershipStatus === 'clubmember'
    },
    hasMemberRequest () {
      return this.info && this.info.membershipStatus === 'requestsent'
    },
    logo () {
      let logo = this.info && this.info.logoUrl
      logo = logo && logo.replace('/-x-/', '/220x-/')
      return logo
    },
    actions () {
      if (!this.info) {
        return
      }
      if (this.info.isManager) {
        const options = [
          { name: 'Изменить обложку', icon: 'image', action: this.changeCover },
          { name: 'Управление клубом', icon: 'settings', action: this.editClub, iconBadge: this.requestsCount }
        ]
        if (this.isMember) {
          options.push(
            { isDivider: true },
            { name: 'Покинуть клуб', icon: 'logout', action: this.leave }
          )
        }
        return options
      }
      return [{ name: 'Покинуть клуб', icon: 'logout', action: this.leave }]
    },
    isReady () {
      return this.$route.params.data || this.isLoaded
    },
    isLoaded () {
      return this.clubInfo && this.clubCode === this.idClub
    },
    nav () {
      const nav = [
        {
          name: 'Обзор',
          link: {
            name: 'Club',
            hash: '#clubTabs'
          }
        }
      ]

      if (!this.isLoaded) {
        return nav
      }

      if (this.info.membersCount) {
        nav.push({
          name: 'Участники',
          link: {
            name: 'ClubMembers',
            hash: '#clubTabs'
          }
        })
      }

      if (this.clubActivitiesCount) {
        nav.push({
          name: 'Тренировки',
          link: {
            name: 'ClubTrainings',
            hash: '#clubTabs'
          }
        })
      }

      if (this.info.isManager || this.clubStartsCount > 0) {
        nav.push({
          name: 'Чемпионаты',
          link: {
            name: 'ClubChamps',
            hash: '#clubTabs'
          }
        })
      }

      return nav
    },
    tenant () {
      return this.$root.$env.VUE_APP_TENANT
    }
  },
  methods: {
    ...mapActions('club', [
      'getClubInfo',
      'setClubBackground',
      'joinClub',
      'leaveClub',
      'getClubActivities',
      'getRequestsCount',
      'getClubStarts'
    ]),
    ...mapActions('clubTraining', ['getClubTrainingCount']),
    ...mapMutations('clubTraining', ['resetClubTraining']),
    ...mapMutations('champs', ['resetChamps']),
    ...mapActions('alerts', ['addSomethingWrongAlert', 'addSuccessAlert']),
    ...mapMutations('club', ['triggerInfoUpdate', 'triggerMembersUpdate', 'clearClub']),
    changeCover () {
      this.$refs.clubCoverInput.open()
    },
    editClub () {
      this.$router.push({
        name: 'ManageClub',
        params: {
          id: this.idClub,
          data: this.info
        }
      })
    },
    loadCover () {
      const input = this.$refs.clubCoverInput
      if (input.hasError) {
        let text = 'Размер файла не должен превышать <b>' + this.coverImgMaxSize + ' МБ</b>'
        if (input.formatError) {
          text = 'Неверный формат файла'
        }
        this.addSuccessAlert(text)
      } else {
        input.getImage().then((img) => {
          if (img) {
            this.coverIsLoading = true
            this.setClubBackground({
              clubId: this.info.id,
              image: img,
              imageName: input.fileName
            })
              .then((response) => {
                this.coverIsLoading = false
                if (response.data.isSuccess) {
                  this.coverImg = img
                  this.clubInfo.backgroundUrl = img
                  return
                }
                this.addSomethingWrongAlert(response.data.errorMessage)
              })
              .catch(() => {
                this.addSomethingWrongAlert()
                this.coverIsLoading = false
              })
          }
        })
      }
    },
    join (redirected) {
      if (!this.isAuthorized) {
        this.login()
        return
      }
      this.isJoining = true
      this.joinClub({
        clubId: this.info.id
      })
        .then((response) => {
          this.isJoining = false
          if (response.data.isSuccess) {
            if (response.data.status === 'clubmember') {
              this.addSuccessAlert('Вы вступили в клуб')
              this.clubInfo.membershipStatus = 'clubmember'
              this.triggerInfoUpdate()
              this.triggerMembersUpdate()
            } else {
              this.addSuccessAlert('Заявка на&nbsp;вступление в&nbsp;клуб отправлена')
              this.clubInfo.membershipStatus = 'requestsent'
            }
            return
          }
          if (!redirected && response.data.errorMessage === 'Not authorized') {
            this.login()
          } else {
            this.addSomethingWrongAlert(response.data.errorMessage)
          }
        })
        .catch(() => {
          this.isJoining = false
          this.addSomethingWrongAlert()
        })
    },
    login () {
      const returnUrl = `${window.location.origin}${this.$route.path}?joinClub`
      const domain = this.$getEnvVar('VUE_APP_RR_URL')
      window.location.href = `${domain}user/login?returnUrl=${returnUrl}`
    },
    cancel () {
      this.isCancelling = true
      this.leaveClub({
        clubId: this.info.id
      })
        .then((response) => {
          this.isCancelling = false
          if (response.data.isSuccess) {
            this.addSuccessAlert('Ваша заявка отменена')
            this.clubInfo.membershipStatus = null
            return
          }
          this.addSomethingWrongAlert(response.data.errorMessage)
        })
        .catch(() => {
          this.isCancelling = false
          this.addSomethingWrongAlert()
        })
    },
    leave () {
      this.leaveClub({
        clubId: this.info.id
      })
        .then((response) => {
          if (response.data.isSuccess) {
            this.addSuccessAlert('Вы успешно вышли из клуба')
            this.clubInfo.membershipStatus = null
            this.triggerInfoUpdate()
            this.triggerMembersUpdate()
            return
          }
          this.addSomethingWrongAlert(response.data.errorMessage)
        })
        .catch(() => {
          this.addSomethingWrongAlert()
        })
    },
    onJoinRedirect () {
      const query = Object.assign({}, this.$route.query)
      delete query.joinClub
      this.$router.replace({ query })

      if (this.isMember || this.hasMemberRequest) {
        return
      }
      this.join(true)
    }
  },
  watch: {
    info: {
      handler (val) {
        if (!val) {
          return
        }
        if (typeof this.$route.query.joinClub !== 'undefined') {
          this.onJoinRedirect()
        }
        if (val.backgroundUrl) {
          this.coverImg = val.backgroundUrl
        }
        if (val.isManager) {
          this.getRequestsCount(this.idClub)
        }
        this.getClubStarts({ clubId: val.id })
      },
      immediate: true
    },
    infoUpdateTrigger (val) {
      if (val) {
        this.getClubInfo(this.idClub)
        this.getClubActivities(this.idClub)
      }
    }
  },
  mounted () {
    this.coverImg = this.info && this.info.backgroundUrl
    this.getClubInfo(this.idClub)
    this.getClubActivities(this.idClub)
  },
  created () {
    if (this.clubCode && this.clubCode !== this.idClub) {
      this.clearClub()
      this.resetClubTraining()
      this.resetChamps()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/clubs";

.club-intro {
  background-color: $color-white;
  box-shadow: $elevation-deth-4;
}

.club-header {
  padding: 0 16px;
  position: relative;

  @media (min-width: breakpoint(md)) {
    padding: 0 32px;
  }
}

.club-title {
  word-break: break-word;
}

.club-avatar {
  position: absolute;
  bottom: 100%;
  margin-bottom: 16px;

  @media (max-width: breakpoint(md, max)) {
    width: 96px;
    height: 96px;
  }

  @media (max-width: 359px) {
    width: 72px;
    height: 72px;
  }
}

.club-cover {
  height: 40vw;
  position: relative;
  background-color: map_get($color-neutral-black, 4);
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  margin-bottom: 32px;
  background-size: cover;
  background-position: center;
  min-height: 150px;

  @media (min-width: breakpoint(md)) {
    height: 33vw;
  }

  @media (min-width: breakpoint(lg)) {
    height: 334px;
  }

  &__empty {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: 56px;

    .overlay {
      background-image: $gradient-horizontal-primary;
      opacity: 0.85;
    }
  }
}

.club-details {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  margin-right: -20px;
  margin-bottom: -4px;

  &__item {
    margin-right: 20px;
    margin-bottom: 4px;
  }
}

.club-buttons-col {

  @media (max-width: breakpoint(md, max)) {
    margin: 0;
  }
}

.club-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: -8px;
  margin-bottom: -8px;

  @media (max-width: breakpoint(md, max)) {
    position: absolute;
    bottom: 100%;
    right: 16px;
    margin-bottom: 8px;
  }

  &__item {
    flex: 0 0 auto;
    max-width: 100%;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
</style>
